import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { styled, css, useTheme } from 'styled-components';
import Icons from '../../Elements/Icons/index.js';
import { Media } from '../../theme/Media.js';
import { Tooltip } from '../../V2/Feedback/Tooltip/index.js';
import { useTableContext } from './context.js';
const TooltipIcon = styled(Icons.QuestionCircle) `
  margin-left: 3px;
`;
const Icon = styled(Icons.Sort) `
  flex: 0 0 auto;
  margin-left: 5px;
`;
export const Wrapper = styled.th `
  cursor: ${({ $sortable }) => $sortable && 'pointer'};
  user-select: none;
  font-weight: normal;
  ${({ $secondaryCell, $isCollapsedNav }) => $secondaryCell &&
    css `
      @media ${$isCollapsedNav ? Media.lgMin : Media.xlgMin} {
        width: 1px;
      }
    `}
  ${({ $mainCell, $isCollapsedNav }) => $mainCell &&
    css `
      @media ${$isCollapsedNav ? Media.lgMin : Media.xlgMin} {
        width: 100%;
      }
    `}
  ${({ $mainCell, $secondaryCell, $isCollapsedNav, $width }) => !$mainCell &&
    !$secondaryCell &&
    $width &&
    css `
      @media ${$isCollapsedNav ? Media.lgMin : Media.xlgMin} {
        width: ${`${$width}px`};
      }
    `}
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.mdMax : Media.lgMax)} {
    display: flex;
  }
`;
export const Container = styled.div `
  display: flex;
  align-items: center;
  ${({ $align }) => $align === 'left' &&
    css `
      justify-content: flex-start;
    `}
  ${({ $align }) => $align === 'center' &&
    css `
      justify-content: center;
    `}
  ${({ $align }) => $align === 'right' &&
    css `
      justify-content: flex-end;
    `}
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.grey100_1};
  padding: ${({ $padding }) => $padding || '10px 14px'};
  white-space: ${({ $nowrap }) => $nowrap && 'nowrap'};
  padding-right: ${({ $sortPlaceholder }) => $sortPlaceholder && '39px'};
`;
const Th = ({ children, order = undefined, handleChangeOrder, className, colSpan, dataTestId, align = 'left', nowrap, type, basis, padding, tooltip, $width, sortPlaceholder, }) => {
    const theme = useTheme();
    const { isCollapsedNav } = useTableContext();
    const checkMobile = useMediaQuery({ query: isCollapsedNav ? Media.mdMax : Media.lgMax });
    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        setIsMobile(checkMobile);
    }, [checkMobile]);
    if (isMobile && !handleChangeOrder && !(type === 'action')) {
        return null;
    }
    return (_jsx(Wrapper, { $sortable: !!handleChangeOrder, onClick: handleChangeOrder, className: className, colSpan: colSpan, "data-testid": dataTestId, $mainCell: basis === 'main', $secondaryCell: basis === 'secondary', $isCollapsedNav: isCollapsedNav, $width: $width, children: _jsxs(Container, { $align: align, $nowrap: nowrap, $padding: padding, $sortPlaceholder: sortPlaceholder, children: [children, tooltip && (_jsx(Tooltip, { placement: 'top', tooltip: tooltip, children: _jsx(TooltipIcon, { size: 14, color: theme.colors.link100 }) })), handleChangeOrder && _jsx(Icon, { sort: order, size: 20 })] }) }));
};
export default React.memo(Th);
